import { Edit3, Trash2, Plus } from '@/components/icons';
import {
  ContextMenu,
  ContextMenuTrigger,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
} from '../ui/beui';

interface FolderContextMenuProps {
  onRename: () => void;
  onNewFolder: () => void;
  onDelete: () => void;
  children: React.ReactElement<React.HTMLAttributes<HTMLElement>>;
}

/**
 * Right-click actions for a folder in the sidebar. Mirrors the folder ⋯ menu
 * (FolderMenu) so both entry points offer the same accessible actions.
 */
export function FolderContextMenu({ onRename, onNewFolder, onDelete, children }: FolderContextMenuProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger>{children}</ContextMenuTrigger>
      <ContextMenuContent className="w-44 min-w-44" ariaLabel="Folder actions">
        <ContextMenuItem onSelect={onRename}>
          <Edit3 /> Rename
        </ContextMenuItem>
        <ContextMenuItem onSelect={onNewFolder}>
          <Plus /> New folder
        </ContextMenuItem>
        <ContextMenuSeparator />
        <ContextMenuItem tone="destructive" onSelect={onDelete}>
          <Trash2 /> Delete
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
